{
  "version": "f6c5e75428f6f9c375e2d16054afd147a7dad797",
  "deploy_image_tag": "f6c5e75428f6f9c375e2d16054afd147a7dad797"
}
